import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Button, FormControlLabel, Grid, Link } from '@mui/material'
import { Checkbox, TextField } from 'src/Libs/inputs/formik'
import { useFormikContext } from 'formik'
import React from 'react'
import Select from 'src/Libs/inputs/formik/Select'
import { useCountryOptions } from '@e3dc-react/shell/Hooks/useCountryOptions'
import { Trans } from 'react-i18next'
import { INSTALLER_PARTNER } from 'src/Configuration'
import { UserLevel } from 'src/State/User/UserModel'

export interface PasswordForm {
  password: string
  passwordRepeat: string
}

interface CreatePasswordProps {
  userLevel: UserLevel
}

/**
 * Component that holds the form to create a password and edit base data as a user that has been invited by Service
 */
const CreatePasswordForm: React.FC<CreatePasswordProps> = ({ userLevel }) => {
  const { t } = useCustomTranslation()
  const { handleSubmit } = useFormikContext<PasswordForm>()
  const { allCountries } = useCountryOptions()

  return (
    <form onSubmit={handleSubmit}>
      <Grid container>
        <Grid item xs={12} marginBottom={2}>
          <TextField label={t('common.login.user')} name={'username'} disabled />
        </Grid>
        <Grid item xs={12} md={6} marginBottom={2}>
          <TextField label={t('common.firstName')} name={'firstName'} disabled />
        </Grid>
        <Grid item xs={12} md={6} marginBottom={2}>
          <TextField label={t('common.lastName')} name={'lastName'} disabled />
        </Grid>
        <Grid item xs={12} md={6} marginBottom={2}>
          <TextField label={t('common.address')} name={'address'} disabled />
        </Grid>
        <Grid item xs={12} md={6} marginBottom={2}>
          <TextField label={t('common.zipCode')} name={'zipCode'} disabled />
        </Grid>
        <Grid item xs={12} md={6} marginBottom={2}>
          <TextField label={t('common.city')} name={'city'} disabled />
        </Grid>
        <Grid item xs={12} md={6} marginBottom={2}>
          <Select label={t('common.country')} name={'country'} options={allCountries} isSearchable disabled />
        </Grid>
        <Grid item xs={12} md={6} marginBottom={2}>
          <TextField label={t('common.email')} name={'eMail'} disabled />
        </Grid>
        <Grid item xs={12} md={6} marginBottom={2}>
          <TextField label={t('common.phone')} name={'phoneNumber'} disabled />
        </Grid>

        {INSTALLER_PARTNER.includes(userLevel) && (
          <>
            <Grid item xs={12} md={6} marginBottom={2}>
              <TextField label={t('common.company')} name={'companyName'} disabled />
            </Grid>
            {userLevel === 'INSTALLER' && (
              <Grid item xs={12} md={6} marginBottom={2}>
                <TextField label={t('common.ipin')} name={'ipin'} disabled />
              </Grid>
            )}
            <Grid item xs={12}>
              <FormControlLabel control={<Checkbox disabled name={'shopAccess'} />} label={t('user.shopPermission.title')} disabled />
            </Grid>
          </>
        )}
        <Grid item xs={12}>
          <FormControlLabel control={<Checkbox name={'eMailNotification'} />} label={t('administration.users.emailNotification')} disabled />
        </Grid>

        <Grid item xs={12}>
          <TextField name="password" label={t('common.login.password')} type="password" />
        </Grid>
        <Grid item xs={12}>
          <TextField name="passwordRepeat" label={t('common.login.repeatPassword')} type="password" />
        </Grid>
        <Grid item xs={12}>
          <Checkbox
            name={'gdprAccepted'}
            label={<Trans i18nKey="shell.register.acceptGdpr" components={[<Link key="gdpr-link" href="/privacy-protection" target="_blank" />]} />}
          />
        </Grid>
        <Grid item xs={12}>
          <Button type={'submit'} variant="contained" fullWidth sx={theme => ({ marginTop: theme.spacing(3) })}>
            {t('common.save')}
          </Button>
        </Grid>
      </Grid>
    </form>
  )
}

export default CreatePasswordForm
